import {NgModule} from '@angular/core';
import {NgxTypedJsComponent} from './ngx-typed-js.component';

@NgModule({
  declarations: [NgxTypedJsComponent],
  imports: [],
  exports: [NgxTypedJsComponent]
})
export class NgxTypedJsModule {
}
